module.exports = __webpack_public_path__ + "img/品質管理3-3.cc090b14.png";